import React, { useState, useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import {
  PLACE_ORDER_INITIAL_URL,
  PLACE_ORDER_INITIAL_URL_V2,
} from 'constants/urls';
import { swapKeysAndValuesDictionary } from 'utilities/general';
import {
  BILLING_STEP_LABEL,
  INFO_STEP_LABEL,
  PRICE_REVIEW_STEP_LABEL,
  REVIEW_STEP_LABEL,
  SAMPLES_SCIENCE_INFO_STEP_LABEL,
  SAMPLES_STEP_LABEL,
  SLIDES_STEP_LABEL,
} from 'components/OrderForm/WizardNavigator/constants';
import { Stepper, Step, StepButton } from '@mui/material';
import { getOrderFormSteps } from 'components/OrderForm/WizardNavigator/utilities';

const styles = () => ({
  root: {
    width: '90%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  stepper: {
    padding: '24px',
  },
});

const steps = [
  INFO_STEP_LABEL,
  SAMPLES_STEP_LABEL,
  SAMPLES_SCIENCE_INFO_STEP_LABEL,
  SLIDES_STEP_LABEL,
  PRICE_REVIEW_STEP_LABEL,
  BILLING_STEP_LABEL,
  REVIEW_STEP_LABEL,
];

const useStyles = makeStyles()(styles);

export const OrderFormWizardNavigator = (props) => {
  const { onBeforeNavigate, children } = props;
  const location = useLocation();
  const match = useRouteMatch();
  const history = useHistory();
  const [activeStep, setActiveStep] = useState(0);
  const { classes } = useStyles();

  const { orderUUID } = match.params;
  const url = match.path;
  const orderFormSteps = getOrderFormSteps(url);
  const URLStepsMapping = swapKeysAndValuesDictionary(orderFormSteps);

  const handleStepClick = (step) => {
    // If this is from the initial placing order page, a user shouldn't be able
    // to click on anything until this is at least done
    if (
      location.pathname === PLACE_ORDER_INITIAL_URL ||
      location.pathname === PLACE_ORDER_INITIAL_URL_V2
    ) {
      return;
    }

    const urlMapping = orderFormSteps[step];
    const finalUrl = urlMapping.replace(':orderUUID', orderUUID);

    const cancelNavigation = onBeforeNavigate?.({
      step,
      urlMapping,
      url: finalUrl,
      orderUUID,
    });

    if (cancelNavigation) return;

    history.push(finalUrl);
  };

  useEffect(() => {
    if (
      location.pathname === PLACE_ORDER_INITIAL_URL ||
      location.pathname === PLACE_ORDER_INITIAL_URL_V2
    ) {
      setActiveStep(0);
    } else {
      setActiveStep(Number(URLStepsMapping[url]));
    }
  }, [URLStepsMapping, location.pathname, url]);

  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel
        nonLinear
        activeStep={activeStep}
        classes={{
          root: classes.stepper,
        }}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepButton onClick={() => handleStepClick(index)}>
              {label}
            </StepButton>
          </Step>
        ))}
      </Stepper>

      {children}
    </div>
  );
};
